import React, { useState, useEffect } from 'react';
import { translations } from '../data/translations';
import LandingPage from './LandingPage';
import QuitSnusPage from './QuitSnusPage';
import MrPiggyPage from './MrPiggyPage';
import QuitSmokingPage from './QuitSmokingPage'; // Add this import
import NeroDiamantePage from './NeroDiamantePage'; // Add this import
import PrivacyPolicyPage from './PrivacyPolicyPage';
import TermsOfUsePage from './TermsOfUsePage';

const SunnySoftware = ({ initialPage = 'landing' }) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [language, setLanguage] = useState('en');
  const [animationStage, setAnimationStage] = useState(0);

  useEffect(() => {
    const browserLang = navigator.language.slice(0, 2);
    if (translations[browserLang]) {
      setLanguage(browserLang);
    }

    const timer1 = setTimeout(() => setAnimationStage(1), 300);
    const timer2 = setTimeout(() => setAnimationStage(2), 1200);
    const timer3 = setTimeout(() => setAnimationStage(3), 2000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  const t = translations[language] || translations.en;

  console.log('SunnySoftware rendering', { currentPage, t });

  switch (currentPage) {
    case 'quitsnus':
      return <QuitSnusPage language={language} setLanguage={setLanguage} t={t} />;
    case 'mrpiggy':
      return <MrPiggyPage language={language} setLanguage={setLanguage} t={t} />;
    case 'quitsmoking':
      return <QuitSmokingPage language={language} setLanguage={setLanguage} t={t} />;
    case 'nero-diamante':
      return <NeroDiamantePage language={language} setLanguage={setLanguage} t={t} />;
    
    // QuitSnus Privacy and Terms
    case 'quitsnus-privacy':
      return <PrivacyPolicyPage language={language} setLanguage={setLanguage} t={t} app="quitsnus" />;
    case 'quitsnus-terms':
      return <TermsOfUsePage language={language} setLanguage={setLanguage} t={t} app="quitsnus" />;
    
    // Mr Piggy Privacy and Terms
    case 'mrpiggy-privacy':
      return <PrivacyPolicyPage language={language} setLanguage={setLanguage} t={t} app="mrpiggy" />;
    case 'mrpiggy-terms':
      return <TermsOfUsePage language={language} setLanguage={setLanguage} t={t} app="mrpiggy" />;
    
    // QuitSmoking Privacy and Terms
    case 'quitsmoking-privacy':
      return <PrivacyPolicyPage language={language} setLanguage={setLanguage} t={t} app="quitsmoking" />;
    case 'quitsmoking-terms':
      return <TermsOfUsePage language={language} setLanguage={setLanguage} t={t} app="quitsmoking" />;
    
    // Nero Diamante Privacy and Terms
    case 'nero-diamante-privacy':
      return <PrivacyPolicyPage language={language} setLanguage={setLanguage} t={t} app="nero-diamante" />;
    case 'nero-diamante-terms':
      return <TermsOfUsePage language={language} setLanguage={setLanguage} t={t} app="nero-diamante" />;
    
    default:
      return (
        <LandingPage
          language={language}
          setLanguage={setLanguage}
          t={t}
          animationStage={animationStage}
        />
      );
  }
};

export default SunnySoftware;